module.exports = __webpack_public_path__ + "img/12.33fc1ce4.jpg";